/**
 * Per-minute ElevenLabs Dubbing cost. Each (video, target_lang) job
 * yields both the dub audio AND the translated subtitle, so this rate
 * covers both. Tune here when ElevenLabs re-prices. EUR estimate with
 * a small safety markup so we never under-quote the admin.
 */
export const COSTS = {
  dubbingPerMinute: 0.35,
} as const;

export interface DubbingCostInput {
  durationSeconds: number;
  targetLangs: string[];
}

export interface DubbingCostBreakdown {
  perLanguage: number;
  total: number;
}

export function estimateDubbingCost(input: DubbingCostInput): DubbingCostBreakdown {
  const minutes = Math.max(0, input.durationSeconds) / 60;
  const perLanguage = minutes * COSTS.dubbingPerMinute;
  return { perLanguage, total: perLanguage * input.targetLangs.length };
}

export function formatEUR(amount: number): string {
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 2,
  }).format(amount);
}
